import React from 'react'

const SprintPageMobile = () => {
  return (
    <div className=''>Sprint Planner</div>
  )
}

export default SprintPageMobile